import { Button, Drawer, Menu, Row, Space, Switch, Tooltip, Checkbox } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import Modal from "antd/es/modal/Modal";
import i18next from "i18next";
import Icon, { DeleteOutlined, DownloadOutlined, FileExclamationFilled, ZoomInOutlined } from '@ant-design/icons';
import { ReactComponent as filter_icon } from '../../../../assets/images/esri/filter-32.svg'



import Graphic from '@arcgis/core/Graphic';
import SimpleLineSymbol from '@arcgis/core/symbols/SimpleLineSymbol';
import SimpleFillSymbol from '@arcgis/core/symbols/SimpleFillSymbol';
import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol';
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine.js";
import { forwardRef, useEffect, useRef, useState } from 'react';
import GpDownloadComponent from '../geoprocessing/gpDownloadComponent';
import TableToolFilterComponent from '../filter/TableToolFilterComponent';

import { addQueryAnParentTable, queries_state,  } from '../../../../features/queries/queriesSlice';



const TableToolbarComponent = forwardRef(({ mapDiv, mapView, mapLayer, sublayer, featureLayer, featureTable, graphicLayer, columnValues }, ref) => {

    const [filterByExtension, setFilterByExtension] = useState(false);
    const [filterByWhere, setFilterByWhere] = useState();
    const [selection, setSelection] = useState([]);
    const [downloadGPProcess, setDownloadGPProcess] = useState([]);
    const [visiblePanels, setVisiblePanels] = useState(false)

    //Lleva un conteo del número de queries que agrega el usuario
    const [queries, setQueries] = useState([]);

    const dispatch = useDispatch();
    const queriesState = useSelector(queries_state);

    let selectionCopy;

    useEffect(() => {
        //console.log("entra en primer use")
        evalFilterByExtension();
        if (!selectionCopy) {
            selectionCopy = [...selection];

            mapView.watch("extent", () => {
                evalFilterByExtension();
            });

            featureTable.highlightIds.on("change", (event) => {
                let addedRows = event.added; // An array of features added to the selection
                let removedRows = event.removed;  // An array of features removed from the selection

                let currentSelection = []
                let addGraphic = true;
                if (addedRows.length != 0) {
                    currentSelection = currentSelection.concat(addedRows);
                    selectionCopy = selectionCopy.concat(currentSelection)

                    //console.log('array', selectionCopy)
                }
                if (removedRows.length != 0) {
                    currentSelection = currentSelection.concat(removedRows);
                    addGraphic = false
                    selectionCopy = selectionCopy.filter(function (el) {
                        return !currentSelection.includes(el);
                    });
                }
                //graphicLayer.removeAll();
                if (currentSelection.length > 0) {
                    featureLayer.queryFeatures({
                        returnGeometry: true,
                        objectIds: currentSelection
                    }).then((featureSet) => {
                        //graphicLayer.removeAll();
                        featureSet.features.map((feature) => {
                            if (addGraphic) {
                                addFeatureToGraphics(feature);
                            } else {
                                removeFeatureToGraphics(feature)
                            }
                        })
                    }).catch((error) => console.log(error));
                }
                setSelection(selectionCopy);
            });
        }
    }, [filterByExtension])


    /**
     * Función que aplica la sqlExpression sobre la sublayer cuyos datos se muestran en la tabla.
     * Se realiza el filtrado de las entidades mostradas en el mapa.
     * 
     * @param {*} mapView 
     * @param {*} mapLayer 
     * @param {*} sublayer 
     * @param {*} values 
     */
    const filterByExpression = (mapView, mapLayer, sublayer, values) => {
        console.log('query', values)
        mapView.map.layers.forEach((layer) => {
            if (layer.title == mapLayer.name) {
                if (layer.sublayers) {
                    layer.sublayers.forEach((sublayerItem) => {
                        if (sublayerItem.id == sublayer.id) {
                            sublayerItem.definitionExpression = values
                        }
                    })
                }
            }
        })
    }

    const addFeatureToGraphics = (feature) => {
        //console.log('geometry', feature.geometry)
        let symbol;
        if (feature.geometry.declaredClass.toUpperCase().includes("POLYLINE")) {
            symbol = new SimpleLineSymbol({
                color: [51, 255, 233, 0.3],
                width: "15px",
                style: "solid"
            });
        }
        else if (feature.geometry.declaredClass.toUpperCase().includes("POLYGON")) {
            symbol = new SimpleFillSymbol({
                color: [51, 255, 233, 0.3],
                outline: {
                    color: [255, 255, 255],
                    width: 3,
                },
            });
        }
        else if (feature.geometry.declaredClass.toUpperCase().includes("POINT")) {
            symbol = new SimpleMarkerSymbol({
                style: "circle",
                size: "50px",
                color: [51, 255, 233, 0.3],
                outline: {
                    color: [255, 255, 255],
                    width: 3,
                },
            });
        }
        else {
            alert("TODO geometría no contemplada");
        }

        const graphic = new Graphic({
            geometry: feature.geometry,
            symbol: symbol,
        });
        //mapView.graphics.removeAll();
        graphicLayer.add(graphic)
        //mapView.graphics.add(graphic);

    }

    const removeFeatureToGraphics = (feature) => {

        graphicLayer.graphics.forEach(function (graphic) {
            // Compare the geometries using geometryEngine.equals
            var geometriesAreEqual = geometryEngine.equals(graphic.geometry, feature.geometry);

            if (geometriesAreEqual) {
                // Remove the graphic from the view's graphics collection
                graphicLayer.remove(graphic);
            }
        });


        //mapView.graphics.remove(graphic);
    }


    const evalFilterByExtension = () => {
        //console.log('feature')

        if (filterByExtension) {
            featureTable.filterGeometry = mapView.extent;
        }
        else {
            featureTable.filterGeometry = null;
        }
    }



    const getMenuItem = (label, key, icon, children, type) => {
        return {
            key,
            icon,
            children,
            label,
            type,
        };
    }

    /**
     * Función recursiva que combina todas las queries de las tablas relacionadas desde la primera tabla de origen
     * hasta la última tabla hija creada.
     * 
     * Devuelve la query completa que ha dado origen a la tabla cuyo id coincide con idTabla
     * 
     * @param {*} idTabla 
     * @param {*} queryIn 
     * @returns 
     */
    const combinarQueriesPersistencia = (idTabla, queryIn) => {
        console.log("idTabla", idTabla)
        let queryCombined = queryIn;
        console.log("queryCombined", queryCombined)
        let elemento = queriesState.filter(elemento => elemento.tableCreatedId == idTabla)
        let longitud = queryCombined.join(".").length
        let queryOut = queryCombined.join(".").slice(1, longitud - 1).replaceAll(".", " AND ")
        if (elemento.length == 0) {
            //console.log("No hay elementos")
            //console.log("queryOut", queryOut)
            return queryOut;
        }
        else if (elemento.length > 1) {
            console.log("Se ha duplicado el id de la tabla. MAL")
        } else {
            //console.log("idTabla", idTabla)
            console.log("elemento", elemento[0])
            let tableOriginId = elemento[0].tableOriginId
            let query = elemento[0].query
            queryCombined.push(query)
            if (query == "") {
                return queryOut;
            }
            return combinarQueriesPersistencia(tableOriginId, queryCombined)
        }

    }

    const onMenuClick = (e) => {
        let queryIn = [""]
        let queryFinal = combinarQueriesPersistencia(featureTable.id, queryIn)
        //console.log("queryFinal", queryFinal)
        let downloadGPProcessCopy = [...downloadGPProcess];
        //console.log('downloadGPProcessCopy', downloadGPProcessCopy)
        let config = { "uid": Math.random().toString(36).slice(-6) };
        if (e.key == "download_shp") {
            config["format"] = "shp";
        }
        if (e.key == "download_xls") {
            config["format"] = "xls";
        }

        if (e.key == "download_geojson") {
            console.log("geojsooon")
            config["format"] = "geojson";
        }
        console.log("filterByExtension", filterByExtension)
        if (filterByExtension) {
            config["queryGeometry"] = mapView.extent;
        }
        //console.log("filterByWhere", queryFinal)

        
        config["queryWhere"] = queryFinal;
        
  


        downloadGPProcessCopy.push(config);
        setDownloadGPProcess(downloadGPProcessCopy);
    };

    let desktopToolbarStyle = {
        textAlign: "left",
        padding: "10px"
    }

    function toggleModal() {
        setVisiblePanels(!visiblePanels)
    }

    /**
     * Función que combina las sqlExpressions recogidas en cada una de las expresiones aplicadas en el filtro
     * y las combina en una única sqlExpression
     * 
     * @param {*} values 
     * @returns 
     */
    const combineQueries = (values) => {

        let whereClause = "";

        if (values.length != 0) {
            //console.log('hay queries')
            values.forEach(element => {
                whereClause += element.content + " AND "
            });
            const whereClauseCopy = whereClause.substring(0, whereClause.length - 4);
            //console.log(whereClauseCopy)
            return whereClauseCopy;
        } else {
            return whereClause;
        }
    }


    /**
     * Función donde se contruye un objeto para la query y se pasa a la funcion addByFeature
     * A este objeto se le añade la sqlExpression
     * 
     * Si hay queries se hace el filtrado de la tabla
     * Si no hay queries se muestra toda la tabla
     * 
     * @param {*} values 
     */
    const executeQueries = (values) => {
        let objecto = {
            tableOriginId: undefined,
            query: "",
            tableCreatedId: undefined
        }
        let combinacion = combineQueries(values)
        objecto.tableOriginId = featureTable.id
        objecto.query = combinacion

        dispatch(addQueryAnParentTable(objecto))


        const queryCreator = {
            "findBy": "query",
            "content": ""
        }

        queryCreator.content = combineQueries(values)
        ref.current.addByFeature(mapView, mapLayer, sublayer, queryCreator)

    }

    /**
     * Funcqión que aplica el filtrado sobre las entidades visualizadas en el mapa cuando se selecciona el checkbox
     * 
     * @param {*} e 
     */
    const aplicarFiltro = (e) => {
        if(e.target.checked) {
            let queryIn = [""]
            let queryFinal = combinarQueriesPersistencia(featureTable.id, queryIn)
            filterByExpression(mapView, mapLayer, sublayer, queryFinal);
        }else {
            filterByExpression(mapView, mapLayer, sublayer, "");
        }
    }


    return (
        <>
            <Space direction="vertical" style={desktopToolbarStyle}>
                <Space wrap>
                    <Tooltip title={i18next.t('common.tools.table.do_filter_by_extension')}>
                        <Switch
                            checkedChildren={i18next.t('common.tools.table.do_filter_by_extension')}
                            unCheckedChildren={i18next.t('common.tools.table.do_filter_by_extension')}
                            defaultChecked={filterByExtension}
                            onChange={(checked, event) => {
                                featureTable.highlightIds.removeAll();
                                selectionCopy = [];
                                setSelection([]);
                                setFilterByExtension(checked)
                            }} />
                    </Tooltip>

                    <Tooltip title={i18next.t('common.tools.table.do_filter_by_query')}>
                        <Button onClick={(e) => { toggleModal() }}>
                            {<Icon component={filter_icon} />}
                        </Button>
                    </Tooltip>

                    {selection.length > 0 && <Tooltip title={i18next.t('common.tools.table.zoom_selection')}>
                        <Button icon={<ZoomInOutlined />}
                            onClick={(e) => { featureTable.zoomToSelection(); }}>{i18next.t('common.tools.table.zoom_selection')}</Button>
                    </Tooltip>}

                    {selection.length > 0 && <Tooltip title={i18next.t('common.tools.table.clear_selection')}>
                        <Button icon={<DeleteOutlined />}
                            onClick={(e) => {
                                featureTable.highlightIds.removeAll();
                                mapView.graphics.removeAll();
                                setSelection([]);
                            }}>{i18next.t('common.tools.table.clear_selection')}</Button>
                    </Tooltip>}

                    <Menu
                        onClick={onMenuClick}
                        style={{}}
                        mode="vertical"
                        items={[
                            getMenuItem(i18next.t('common.tools.table.download'), 'download', <DownloadOutlined />, [
                                getMenuItem(i18next.t('common.tools.table.download_shp'), 'download_shp'),
                                getMenuItem(i18next.t('common.tools.table.download_xls'), 'download_xls'),
                                getMenuItem(i18next.t('common.tools.table.download_geojson'), 'download_geojson')
                            ])
                        ]}
                    />
                    <Checkbox onChange={aplicarFiltro}>{i18next.t('common.tools.table.apply_filter_in_view')}</Checkbox>
                </Space>
            </Space>
            {
                downloadGPProcess.map((gpConfig) => {
                    return <GpDownloadComponent
                        downloadGPProcess={downloadGPProcess}
                        setDownloadGPProcess={setDownloadGPProcess}
                        format={gpConfig.format}
                        uid={gpConfig.uid}
                        queryGeometry={gpConfig.queryGeometry}
                        queryWhere={gpConfig.queryWhere}
                        featureLayer={featureLayer}></GpDownloadComponent>
                })
            }
            <Modal
                title="Filtro por expresión"
                centered
                open={visiblePanels}
                onOk={() => {
                    setVisiblePanels();
                    setQueries([]);
                    executeQueries(queries);
                }
                }
                onCancel={() => { setVisiblePanels(); setQueries([]); }}
                width={580}>
                <TableToolFilterComponent
                    mapDiv={mapDiv}
                    mapView={mapView}
                    queries={queries}
                    addQuery={setQueries}
                    mapLayer={mapLayer}
                    sublayer={sublayer}
                    featureLayer={featureLayer}
                    columnValues={columnValues}
                    featureTable={featureTable}>
                </TableToolFilterComponent>
            </Modal>
        </>
    )
});
export default TableToolbarComponent;